import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CalendarIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M19 3h-2V2c0-.5-.5-1-1-1a1 1 0 0 0-1 1v1H9V2c0-.5-.5-1-1-1s-1 .4-1 1v1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3ZM5 5h2v1c0 .5.5 1 1 1s1-.5 1-1V5h6v1c0 .5.4 1 1 1 .5 0 1-.5 1-1V5h2c.5 0 1 .5 1 1v3H4V6c0-.5.4-1 1-1Zm14 16H5a1 1 0 0 1-1-1v-9h16v9c0 .6-.4 1-1 1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CalendarIcon;
